"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canIExecuteClientCode = exports.isElementInViewport = exports.canILiftOff = void 0;
var subscribersMap = {};
var addedGlobalEventListeners = false;
/**
 * Returns an element
 * @param {*} elementSelector
 */

var getElement = function getElement(elementSelector) {
  return document.querySelector(elementSelector);
};
/**
 * Iterate through the listeners list and try to resolve
 * the promise if they are visible in the viewport
 * TODO: Fix the viewport detection part
 */


var resolveListeners = function resolveListeners() {
  var subscribersKeyList = Object.keys(subscribersMap);

  if (subscribersKeyList.length > 0) {
    for (var index = 0; index < subscribersKeyList.length; index++) {
      var key = subscribersKeyList[index];

      if (subscribersMap[key]) {
        //Only full load component when is visible in viewport
        if (isElementInViewport(getElement(key))) {
          subscribersMap[key].resolve(true);
          subscribersMap[key] = null;
          delete subscribersMap[key];
        }
      }
    }
  }
};
/**
 * Helper function to simulate a setInterval but
 * wthout hurting the browser performance
 * @param {*} fn
 * @param {*} delay
 */


var requestInterval = function requestInterval(fn, delay) {
  var requestAnimFrame = function () {
    return window.requestAnimationFrame || function hello(callback) {
      window.setTimeout(callback, 1000 / 60);
    };
  }();

  var start = new Date().getTime();
  var handle = {};

  function loop() {
    handle.value = requestAnimFrame(loop);
    var current = new Date().getTime();
    var delta = current - start;

    if (delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }
  }

  handle.value = requestAnimFrame(loop);
  return handle;
};
/**
 * Try to resolve all listeners once an
 * user wants to play with the components
 * this heuristics are very basic, we should
 * find better ones.
 */


var addGlobalEventListeners = function addGlobalEventListeners() {
  window.addEventListener("scroll", function () {
    resolveListeners();
  });
  window.addEventListener("click", function () {
    resolveListeners();
  });
  window.addEventListener("mousemove", function () {
    resolveListeners();
  });
  window.addEventListener("keydown", function () {
    resolveListeners();
  });
  requestInterval(function () {
    resolveListeners();
  }, 2000);
};
/**
 * Returns the DocElement
 */


var getDocElement = function getDocElement() {
  if (window !== undefined) {
    return window.document.documentElement;
  }

  return false;
};
/**
 * Obtaining the viewport height
 * @method _getViewportH
 * @return ConditionalExpression
 */


var getViewportH = function getViewportH() {
  var client = getDocElement.clientHeight;
  var inner = window.innerHeight;
  return client < inner ? inner : client;
};
/**
 * The offset of the element
 * @method _getOffset
 * @param {} el
 * @return ObjectExpression
 */


var getOffset = function getOffset(el) {
  var offsetTop = 0;
  var offsetLeft = 0;
  /* eslint-disable */

  do {
    if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop;
    }

    if (!isNaN(el.offsetLeft)) {
      offsetLeft += el.offsetLeft;
    }
  } while (el = el.offsetParent);
  /* eslint-enable */


  return {
    top: offsetTop,
    left: offsetLeft
  };
};
/**
 * Return true if the element if visible in a viewport zone
 * @param {} el
 * @param {} h
 * @return LogicalExpression
 */


var isElementInViewport = function isElementInViewport(el) {
  if (canIExecuteClientCode() && el) {
    var element = el;
    var top = element.offsetTop;
    var left = element.offsetLeft;
    var width = element.offsetWidth;
    var height = element.offsetHeight;

    while (element.offsetParent) {
      element = element.offsetParent;
      top += element.offsetTop;
      left += element.offsetLeft;
    }

    return top < window.pageYOffset + window.innerHeight && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset;
  }
};
/**
 * Returns a promise that resolves once the initial
 * browser processing is done. This allows to save
 * the users that uses low cpu devices and also have
 * awesome results in Google Page Speed
 * @param {*} elementSelector
 * @param {*} inSSR
 */


exports.isElementInViewport = isElementInViewport;

var canILiftOff = function canILiftOff(elementSelector) {
  var inSSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return new Promise(function (resolve) {
    // we don't need to wait in SSR
    if (window === undefined && inSSR) {
      resolve(true);
    } else {
      // adds global listeners that will trigger
      // once a real person is interacting with the browser
      if (!addedGlobalEventListeners) {
        addGlobalEventListeners();
      } // saving all the component instances subscriptions


      subscribersMap[elementSelector] = {
        resolve: resolve
      };
    }
  });
};

exports.canILiftOff = canILiftOff;

var canIExecuteClientCode = function canIExecuteClientCode() {
  return typeof window !== "undefined";
};

exports.canIExecuteClientCode = canIExecuteClientCode;